/**
 * 🧱 Refactor BT Phase 3 — T1 : objet initial du formulaire d'Éditer — déplacé TEL QUEL depuis
 * EditerBonTravailDialog.jsx (ex-L172-258, corps de `useState({ ... })`). Évalué à l'identique (appel direct).
 */

// Incident I-1 : `form` n'apparaissait que dans un commentaire du bloc HEAD — retiré des dépendances (TDZ).
export function formInitialEditer({ bon }) {
  return {
  description_travaux: bon.description_travaux || '',
  notes_speciales: bon.notes_speciales || '',
  heures_budgetees: bon.heures_budgetees?.toString() || '',
  heures_budgetees_ajustees_manuellement: bon.heures_budgetees_ajustees_manuellement || false,
  heure_debut: bon.heure_debut || '',
  // 🔄 B4 — Dates fixes (lecture du BT existant)
  dates_fixes: !!bon.dates_fixes,
  jours_pluie: bon.jours_pluie || false,
  pluie_date_debut: bon.pluie_date_debut || '',
  pluie_date_fin: bon.pluie_date_fin || '',
  chef_equipe_id: bon.chef_equipe_id || '',
  chef_equipe_nom: bon.chef_equipe_nom || '',
  // 🆕 2026-05-06 Module CCQ — régime applicable au BT
  regime_ccq: bon.regime_ccq || 'hors_ccq',
  produits_selectionnes: (bon.produits || []).map(p => ({
    produit_id: p.produit_id, produit_nom: p.produit_nom, fini: p.fini || '',
    unite: p.unite || 'gallon', quantite: p.quantite || 1, quantite_prevue: p.quantite_prevue || 0,
    emplacement: p.emplacement || '',
    code_couleur: p.code_couleur || '', commande_initiale_faite: p.commande_initiale_faite || false
  })),
  etapes: (bon.etapes || []).map(e => ({ numero: e.numero, description: e.description, completee: e.completee })),
  zones: (bon.zones || []).map(z => ({ numero: z.numero, nom: z.nom, description: z.description || '', photo_url: z.photo_url })),
  dates_chantier: bon.dates_chantier || [],
  equipements_selectionnes: (bon.equipements || []).map(e => ({
    equipement_id: e.equipement_id, equipement_nom: e.equipement_nom,
    emoji: e.emoji, dates_utilisation: e.dates_utilisation || [],
    nb_etages_utilises: e.nb_etages_utilises || 0,
    apporter_lavage: e.apporter_lavage || false,
    notes_lavage: e.notes_lavage || '',
  })),
  lavage_pression_a_faire: bon.lavage_pression_a_faire || false,
  nacelle_lavage_requise: bon.nacelle_lavage_requise || false,
  nacelle_retour: bon.nacelle_retour || 'bureau',
  nacelle_apport_timing: bon.nacelle_apport_timing || 'jour_j',
  echafauds_a_monter: bon.echafauds_a_monter || false,
  echafauds_remorque_retour: bon.echafauds_remorque_retour || 'bureau',
  echafauds_date_demontage: bon.echafauds_date_demontage || '',
  echafauds_utilises: bon.echafauds_utilises || [],  // ✅ NOUVEAU : Array d'échafaudages multi-types
  echafauds_tours_config: bon.echafauds_tours_config || [],  // ✅ NOUVEAU : Configuration des tours par zone
  nettoyer_echelle: bon.nettoyer_echelle || false,  // ✅ 2026-04-22 : Case à cocher "Nettoyer à l'échelle"
  nettoyer_echelle_type_pieds: bon.nettoyer_echelle_type_pieds || null,  // 🆕 2026-05 : "24" ou "32"
  type_etage_echafauds: bon.type_etage_echafauds || '',  // ✅ ÉTAPE 4 (Legacy, peut être supprimé plus tard)
  dimensions_etage_echafauds: bon.dimensions_etage_echafauds || '',  // ✅ ÉTAPE 4 (Legacy)
  nb_etages_utilises: bon.nb_etages_utilises || 0,  // (Legacy)
  notes_lavage_pression: bon.notes_lavage_pression || '',
  date_lavage_prevu: bon.date_lavage_prevu || '',
  notes_importantes: bon.notes_importantes || '',
  notes_importantes_timing: bon.notes_importantes_timing || 'debut_travaux',
  // ✅ NOUVEAUX CHAMPS : Gestion avancée nacelle/échafauds dans Équipements de location
  equipements_nacelle_requise: bon.equipements_nacelle_requise || false,
  equipements_nacelle_id: bon.equipements_nacelle_id || null,
  equipements_nacelle_dates: (bon.equipements_nacelle_dates || []).map(d => ({
    date: d.date,
    // 🆕 2026-05 : multi-zones par jour. Compat ascendante avec ancien `zone_numero`.
    zones_numeros: Array.isArray(d.zones_numeros)
      ? d.zones_numeros
      : (d.zone_numero != null ? [d.zone_numero] : []),
    notes_positionnement: d.notes_positionnement || '',
  })),  // [{date, zones_numeros, notes_positionnement}]
  equipements_nacelle_retour_type: bon.equipements_nacelle_retour_type || 'bureau',  // 'bureau' ou 'autre_chantier'
  equipements_nacelle_client_livraison: bon.equipements_nacelle_client_livraison || null,  // {client_id, client_nom, adresse}
  // ✅ PHASE 1 & 2 : Livraison nacelle avancée
  equipements_nacelle_livraison_timing: bon.equipements_nacelle_livraison_timing || 'jour_j',  // 'veille' ou 'jour_j'
  equipements_nacelle_vehicule_livraison_id: bon.equipements_nacelle_vehicule_livraison_id || null,
  equipements_nacelle_vehicule_livraison_nom: bon.equipements_nacelle_vehicule_livraison_nom || null,
  equipements_echafauds_requis: bon.equipements_echafauds_requis || false,
  equipements_echafauds_utilises: bon.equipements_echafauds_utilises || [],  // Même structure que echafauds_utilises
  equipements_echafauds_zones: bon.equipements_echafauds_zones || [],  // [zone_numero]
  // 🆕 2026-04-30 — Matrice présence par jour (édition)
  // 🐛 [v13.62 — 2026-02-28] BUG RACINE : `bon.chef_dates_assignees || []` transformait
  //   silencieusement `null` (legacy implicite = « chef présent toutes les dates du
  //   chantier ») en `[]` (explicite vide = « chef absent partout »). Combiné à
  //   l'auto-save Phase 43 BIS (debounce 3s) qui persiste toute mutation de `form`,
  //   ce fallback écrasait l'état legacy dès le simple mount du dialog → chef
  //   marqué absent partout → message d'horaire signale « BT sans chef », employés
  //   ne voient pas le chantier dans Mon Espace, ne peuvent pas se puncher.
  //   Convention canonique (cf. `/app/backend/lib/bt_equipe_normalize.py`) :
  //     - `null` = legacy implicite (fallback dc pour l'affichage)
  //     - `[]`   = explicite vide (intention utilisatrice « absent partout »)
  //     - `[dates...]` = dates explicites
  //   On préserve strictement la valeur DB — seul un tableau devient un tableau,
  //   toute autre valeur (null / undefined / non-array) reste `null` (implicite).
  chef_dates_assignees: Array.isArray(bon.chef_dates_assignees) ? bon.chef_dates_assignees : null,
  chefs_par_jour: bon.chefs_par_jour || {}, // 🆕 2026-05 : chef différent par jour
  employes_assignes: bon.employes_assignes || [],
  // 🛡️ [Phase 57 — v11] Mémoire DB des extras retirés explicitement (cf. L90)
  employes_extras_retires_explicitement: bon.employes_extras_retires_explicitement || [],
  };
}
